import { render, staticRenderFns } from "./SmallHeading.vue?vue&type=template&id=72ce4060&scoped=true&"
import script from "./SmallHeading.vue?vue&type=script&lang=ts&"
export * from "./SmallHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce4060",
  null
  
)

export default component.exports